import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "commitmentCard",
    "statusSelect",
    "genderSelect",
    "countrySelect",
    "levelSelect",
  ];

  connect() {
    // Check initial status and show/hide commitment card
    setTimeout(() => {
      this.checkStatusAndToggleCard();
    }, 100);
  }

  // Initialize level of competition options if gender and country are already selected
  levelSelectTargetConnected() {
    if (this.hasGenderSelectTarget && this.hasCountrySelectTarget) {
      setTimeout(() => {
        this.filterLevelOfCompetitionOptions();
      }, 100);
    }
  }

  /**
   * ================================
   * Commitments Status Card
   * ================================
   */
  checkStatusAndToggleCard() {
    if (!this.hasCommitmentCardTarget || !this.hasStatusSelectTarget) return;

    // Check if the current value is "committed"
    const isCommitted = this.statusSelectTarget.value === "committed";

    // Toggle the card visibility
    if (isCommitted) {
      this.commitmentCardTarget.classList.remove("hidden");
    } else {
      this.commitmentCardTarget.classList.add("hidden");
    }
  }

  // Method to handle status change
  handleStatusChange(event) {
    this.checkStatusAndToggleCard();
  }

  toggleCommitmentCard() {
    const status = this.statusSelectTarget.value;
    this.commitmentCardTarget.classList.toggle(
      "hidden",
      status !== "committed"
    );
  }

  /**
   * ================================
   * Level of Competition Options
   * ================================
   */
  // Method to handle gender change
  handleGenderChange(event) {
    this.filterLevelOfCompetitionOptions();
  }

  // Method to handle country change
  handleCountryChange(event) {
    this.filterLevelOfCompetitionOptions();
  }

  // Filter level of competition options based on gender and country
  filterLevelOfCompetitionOptions() {
    console.log(
      "[filterLevelOfCompetitionOptions]",
      this.hasGenderSelectTarget,
      this.hasCountrySelectTarget,
      this.hasLevelSelectTarget
    );
    if (
      !this.hasGenderSelectTarget ||
      !this.hasCountrySelectTarget ||
      !this.hasLevelSelectTarget
    )
      return;

    const gender = this.genderSelectTarget.value;
    const country = this.countrySelectTarget.value;

    console.log("[gender]", gender);
    console.log("[country]", country);

    // Get the fancy select controller for level of competition
    const levelSelectController =
      this.application.getControllerForElementAndIdentifier(
        this.levelSelectTarget.closest(
          "[data-controller='shared--fancy-select']"
        ),
        "shared--fancy-select"
      );

    console.log("[levelSelectController]", levelSelectController, {
      select: this.levelSelectTarget,
    });

    if (!levelSelectController) return;

    // Get all option items
    const itemTargets = levelSelectController.itemTargets;

    // If no gender or country is selected, show only default options
    if (!gender || !country) {
      console.log("🅾️[no gender or country]", {
        gender,
        country,
      });
      itemTargets.forEach((item) => {
        const dataFilter = item.dataset.filter;
        console.log("[dataFilter]", dataFilter);
        if (dataFilter === "none") {
          console.log(
            "🅾️[dataFilter]",
            dataFilter,
            "class before",
            item.classList
          );
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      });
      return;
    }

    // Create the filter string
    const filterString = `${country}_${gender}`;

    // Show/hide options based on the filter
    // Always show default options (none) plus country-specific options
    itemTargets.forEach((item) => {
      const dataFilter = item.dataset.filter;
      console.log("[dataFilter]", dataFilter, {
        filterString,
        equals: dataFilter === filterString,
      });
      if (dataFilter === filterString || dataFilter === "none") {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
        console.log("DAVAM HIDDEN [item]", item.dataset.id);
      }
    });
  }
}
